import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers';

export const OnlineContent: FC = ({ children }) => {
  const isOnline = useSelector((state: RootState) => state.appStatus.isOnline);
  if (!isOnline) return null;
  return <>{children}</>;
};
